import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../lib/utils";

const buttonVariants = ({
  variant = "default",
  size = "default",
  className,
}) => {
  return cn(
    "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
    {
      "bg-primary text-primary-foreground shadow hover:bg-primary/90":
        variant === "default",
      "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90":
        variant === "destructive",
      "border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground":
        variant === "outline",
      "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80":
        variant === "secondary",
      "bg-ghost text-ghost-foreground hover:bg-ghost/80": variant === "ghost",
      "bg-link text-link-foreground hover:bg-link/80": variant === "link",
    },
    {
      "h-9 px-4 py-2": size === "default",
      "h-7 rounded-md px-3": size === "sm",
      "h-10 rounded-md px-8": size === "lg",
      "h-9 w-9": size === "icon",
    },
    className
  );
};

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
